"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
var SERVICE_NAME = 'prSavedFiltersService';
var SAVED_FILTERS_BASE_PATH = '/filters-service/';
(function (module) {
    module.factory(SERVICE_NAME, [
        '$http',
        '$cacheFactory',
        'prFieldsets',
        'pr.navigationService',
        '$location',
        function ($http, $cacheFactory, prFieldsets, 
        // @ts-ignore
        navigationService, $location) {
            var cache = $cacheFactory(SERVICE_NAME);
            var PROTOCOLS = {
                GET: 'get',
                POST: 'post',
                PUT: 'put'
            };
            // @ts-ignore
            function SavedFilters(sourceId) {
                // @ts-ignore
                this.sourceId = sourceId;
            }
            SavedFilters.isSavedFiltersUrl = function (url) {
                return lodash_1.default.includes(url, SAVED_FILTERS_BASE_PATH);
            };
            SavedFilters.clearCache = function () {
                cache.removeAll();
            };
            var proto = SavedFilters.prototype;
            // @ts-ignore
            proto.getSavedFiltersUrl = function (fieldsetId) {
                var baseUrl = $location.protocol() + '://' + $location.host() + SAVED_FILTERS_BASE_PATH + 'v1/fieldsets/';
                return baseUrl + fieldsetId + '/filters?surveyId=' + this.sourceId;
            };
            // @ts-ignore
            // @ts-ignore
            proto._makeRequest = function (protocol, body) {
                var _this = this;
                return prFieldsets.getFieldsetBySourceId(this.sourceId).then(function (fs) {
                    var url = _this.getSavedFiltersUrl(fs.definition.fieldSetId);
                    if (protocol === PROTOCOLS.GET) {
                        return $http.get(url, { cache: cache });
                    }
                    // @ts-ignore
                    return $http[protocol](url, body);
                });
            };
            // @ts-ignore
            proto.updateFilters = function (filterChanges) {
                // @ts-ignore
                return this._makeRequest(PROTOCOLS.PUT, filterChanges).then(function (res) {
                    return res.data;
                });
            };
            /**
             * Retrieves the requested saved filter, if it exists.
             * @param  {object} filterDef - the filter to retrieve
             * @param  {object} [options]
             *   @property {boolean} [includeMatchingDefinition]
             *      If true, returns any saved filter with the same definition and name.
             *      Otherwise, returns only the saved filter with the same filterId
             * @return {[type]}           [description]
             */
            // @ts-ignore
            // @ts-ignore
            proto.getExistingFilter = function (filterDef, options) {
                options = options || {};
                // @ts-ignore
                return this.getFilters().then(function (filters) {
                    var withSameId = lodash_1.default.find(filters, function (candidateFilter) {
                        return candidateFilter.filterId === filterDef.filterId;
                    });
                    if (withSameId) {
                        return withSameId;
                    }
                    if (options.includeMatchingDefinition) {
                        return lodash_1.default.find(filters, function (candidateFilter) {
                            return candidateFilter.filterName === filterDef.filterName &&
                                lodash_1.default.isEqual(candidateFilter.filter, filterDef.filter);
                        });
                    }
                });
            };
            /**
             * Retrieves all fieldset filters
             */
            proto.getFilters = function () {
                var _this = this;
                // @ts-ignore
                return this._makeRequest(PROTOCOLS.GET).then(function (res) {
                    return lodash_1.default.get(res, 'data.filters', []);
                    // @ts-ignore
                }).catch(function (error) {
                    console.error('Unable to fetch filters from filters-service. Reading from fieldset definition...', error);
                    return prFieldsets.getFieldsetBySourceId(_this.sourceId).then(function (fieldset) {
                        return fieldset.definition.fscsFilters;
                    });
                });
            };
            // @ts-ignore
            proto.getUpdatedDefinition = function (filterDef) {
                var _this = this;
                this.filterDef = filterDef;
                // @ts-ignore
                return this.getExistingFilter(filterDef).then(function (newFilterDef) {
                    if (newFilterDef) {
                        var updatedFilters = {};
                        lodash_1.default.extend(updatedFilters, {
                            type: newFilterDef.filter.type,
                            filter: newFilterDef.filter.filter,
                            children: newFilterDef.filter.children
                        }, {
                            filterId: newFilterDef.filterId,
                            name: newFilterDef.filterName,
                            timezone: newFilterDef.timezone
                        });
                        return updatedFilters;
                    }
                    else {
                        // Unable to find the given filterId in the fieldset filters
                        return _this.filterDef;
                    }
                    // @ts-ignore
                }).catch(function (err) {
                    console.error('Unable to fetch latest saved filter definition: ', err);
                    return _this.filterDef;
                });
            };
            // @ts-ignore
            // @ts-ignore
            proto.isSavedFilter = function (filterDef, optSourceId) {
                if (!filterDef) {
                    return false;
                }
                return optSourceId ? !!(filterDef[optSourceId] || {}).filterId :
                    !!filterDef.filterId;
            };
            return SavedFilters;
        }
    ]);
})(angular_1.module('qualtrics.pr'));
